const setAnswerHeight = (answer) => {
  answer.style.maxHeight = answer.scrollHeight + 'px';
};

const watchAnswerContent = (item, answer) => {
  if (item._faqObserver) return;

  const update = () => {
    if (item.classList.contains('active')) {
      setAnswerHeight(answer);
    }
  };

  const observer = new ResizeObserver(update);
  observer.observe(answer);
  item._faqObserver = observer;

  answer.querySelectorAll('img').forEach(img => {
    if (img.complete && img.naturalHeight !== 0) return;
    img.addEventListener('load', update, { once: true });
    img.addEventListener('error', update, { once: true });
  });

  answer.querySelectorAll('video').forEach(video => {
    video.addEventListener('loadedmetadata', update, { once: true });
  });
};

const initFAQ = () => {
  const faqItems = document.querySelectorAll('.faq__item');

  if (faqItems.length === 0) return;

  faqItems.forEach(item => {
    const question = item.querySelector('.faq__question');
    const answer = item.querySelector('.faq__answer');

    if (!question || !answer) return;

    question.addEventListener('click', () => {
      const isActive = item.classList.contains('active');

      faqItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.classList.remove('active');
          const otherQuestion = otherItem.querySelector('.faq__question');
          const otherAnswer = otherItem.querySelector('.faq__answer');
          if (otherQuestion && otherAnswer) {
            otherQuestion.setAttribute('aria-expanded', 'false');
            otherAnswer.style.maxHeight = '0';
          }
        }
      });

      if (isActive) {
        item.classList.remove('active');
        question.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = '0';
      } else {
        item.classList.add('active');
        question.setAttribute('aria-expanded', 'true');
        setAnswerHeight(answer);
        watchAnswerContent(item, answer);
      }
    });
  });
};

const initFAQVideos = async () => {
  const faqVideos = document.querySelectorAll('.faq__video');

  if (faqVideos.length === 0) return;

  // video.js is large, so it is only downloaded when the FAQ has a video
  const { default: videojs } = await import('video.js');

  faqVideos.forEach(videoContainer => {
    const video = videoContainer.querySelector('video');
    const playButton = videoContainer.querySelector('.faq__video-button');

    if (!video || !playButton) return;

    try {
      const videoPlayer = videojs(video, {
        controls: true,
        autoplay: false,
        preload: 'auto',
        bigPlayButton: false,
        responsive: true,
        fluid: true
      });

      playButton.addEventListener('click', () => {
        videoPlayer.play();
      });

      videoPlayer.on('play', () => {
        playButton.style.display = 'none';
      });

      videoPlayer.on('ended', () => {
        playButton.style.display = 'block';
        videoPlayer.pause();
      });

      videoPlayer.on('pause', () => {
        playButton.style.display = 'block';
      });

      const faqItem = videoContainer.closest('.faq__item');
      if (faqItem) {
        const question = faqItem.querySelector('.faq__question');
        if (question) {
          question.addEventListener('click', () => {
            setTimeout(() => {
              if (!faqItem.classList.contains('active')) {
                videoPlayer.pause();
              }
            }, 100);
          });
        }
      }

    } catch (err) {
      console.log('FAQ Video initialization error:', err);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initFAQ();
  initFAQVideos();
});

export { initFAQ, initFAQVideos };
